import { FEEDBACK_SUPPLIER_PROFILES, type FeedbackSupplier } from '@erp/rpc';

import { downloadExceptionListTemplate } from './exceptionListTemplate';
import { MassRenewalCardView } from './MassRenewalCardView';
import { RenewalRulesPanel } from './RenewalRulesPanel';
import { useMassRenewal } from './useMassRenewal';
import { useRenewalRules } from './useRenewalRules';

/** A supplier's Mass Renewal card, wired to the org's latest run for it, its Renewal Rules and the API. */
export function MassRenewalCard({ supplier }: { supplier: FeedbackSupplier }) {
  const profile = FEEDBACK_SUPPLIER_PROFILES[supplier];
  const renewal = useMassRenewal(profile);
  const { rules } = useRenewalRules(supplier);
  return (
    <MassRenewalCardView
      supplier={profile}
      run={renewal.run}
      runLoading={renewal.runLoading}
      runError={renewal.runError}
      drop={renewal.drop}
      phase={renewal.phase}
      blocker={renewal.blocker}
      downloading={renewal.downloading}
      ruleCount={rules.length}
      rulesPanel={<RenewalRulesPanel supplier={supplier} />}
      onFiles={renewal.addFiles}
      onMove={renewal.moveFile}
      onRemove={renewal.removeFile}
      onStart={renewal.start}
      onDownload={(letter, file) => void renewal.download(letter, file)}
      onDownloadTemplate={downloadExceptionListTemplate}
    />
  );
}
